import { parseUrlHash } from "./url/url";

export const URLInitAction = {
  listen: "listen",
};

const DELIMITER_ACTION_DATA = ":";
const DELIMITER_DATA_VALUES = "|";

export const makeHashInitActionListen = (id, position) => {
  if ("window" in global) {
    return window.location.pathname
      + "#initAction=listen"
      + DELIMITER_ACTION_DATA
      + id
      + (position === undefined ? "" : DELIMITER_DATA_VALUES + position);
  }

  return "";
};

export const parseHashInitAction = (url) => {
  const parseUrl = parseUrlHash(url);
  if (parseUrl.initAction) {
    const [action, data] = parseUrl.initAction.split(DELIMITER_ACTION_DATA);
    if (action === URLInitAction.listen) {
      const [id, position] = data.split(DELIMITER_DATA_VALUES);
      return { action, id, position, };
    }
  }

  return null;
};

